// extracted by mini-css-extract-plugin
module.exports = {"root":"n60-footer_root__K_FWL","grid":"n60-footer_grid__nqPdF","divider":"n60-footer_divider__aagbh","gridDivider":"n60-footer_gridDivider__4HhOw"};